"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _state = require("printableWorksheets/state");
var _react = _interopRequireDefault(require("react"));
require("./styles.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var SubjectSelector = function SubjectSelector() {
  var _subjectCodeToTitleMa;
  var subjectCodeToTitleMapper = (_subjectCodeToTitleMa = {}, _defineProperty(_subjectCodeToTitleMa, _state.SubjectCodes.MATH, 'Math'), _defineProperty(_subjectCodeToTitleMa, _state.SubjectCodes.ELA, 'English'), _subjectCodeToTitleMa);
  var _usePrintableWorkshee = (0, _state.usePrintableWorksheetsState)(),
    subjectCode = _usePrintableWorkshee.subjectCode,
    setSubjectCode = _usePrintableWorkshee.setSubjectCode;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "grade-selector",
    "data-sentry-component": "SubjectSelector",
    "data-sentry-source-file": "subjectSelector.tsx"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "heading"
  }, " Subject"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "grades-container subject-selector"
  }, Object.keys(_state.SubjectCodes).map(function (subject) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: subject,
      onClick: function onClick() {
        return setSubjectCode(_state.SubjectCodes[subject]);
      },
      className: "grade ".concat(_state.SubjectCodes[subject] == subjectCode ? 'selected' : '')
    }, subjectCodeToTitleMapper[_state.SubjectCodes[subject]]);
  })));
};
var _default = SubjectSelector;
exports["default"] = _default;